<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-4 space-y-2 md:space-y-0">
      <span class="font-semibold text-primario text-lg tracking-wide">
        {{ $t("lang.msg.cancelledComercialRequests") }}
      </span>
    </div>
    <datatable
      :data="data"
      :headers="headers"
      @on-row-click="openEditModal"
    />
  </div>
</template>
<script>
import AdminMixin from "@/components/mixins/AdminMixin";
import DataTable from "@/components/shared/DataTable";

export default {
  name: "DiscontinuedComercialRequest",
  mixins: [AdminMixin],
  components: {
    datatable: DataTable
  },
  data() {
    return {
      data: [],
      headers: {
        comercialRequstReference: "Referencia",
        employeeName: "Usuario",
        comercialRequestCancellationDate: {
          type: "datetime",
          name: "Fecha"
        },
        comercialRequestCancellationReason: "Motivo"
      }
    };
  },
  created() {
    this.fetchData(
      `api/ComercialRequestCancelleds/GetAllComercialRequestCancelled`
    );
  }
};
</script>